import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { UserMatchGuard } from './guards/match.guard';
import { maintenanceGuard } from './guards/maintenance.guards';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';


export const routes: Routes = [
  {
    path: '**',                           // catches EVERY url
    canMatch: [maintenanceGuard],
    component: ComingSoonComponent,
    title: 'Maintenance | Pankhudi',
  },
  {
    path: 'admin',
    children: [
      {
        path: '',
        children: [
          {
            path: 'dashboard',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/dashboard/dashboard.component').then(c => c.DashboardComponent),
            title: 'Dashboard | Pankhudi'
          },
          {
            path: 'user-login-summary',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/mis-report/mis-report.component').then(c => c.MisReportComponent),
            title: 'User Login Summary | Pankhudi'
          },
          {
            path: 'contributor-dashboard',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/contributor-dashboard/contributor-dashboard.component').then(c => c.ContributorDashboardComponent),
            title: 'Contributor Dashboard | Pankhudi'
          },
          {
            path: 'checker-dashboard',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/checker-dashboard/checker-dashboard.component').then(c => c.CheckerDashboardComponent),
            title: 'Checker Dashboard | Pankhudi'
          },
          {
            path: 'maker-dashboard',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/maker-dashboard/maker-dashboard.component').then(c => c.MakerDashboardComponent),
            title: 'Maker Dashboard | Pankhudi'
          },
          {
            path: 'projects',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/project/project-list/project-list.component').then(c => c.ProjectListComponent),
            title: 'Projects | Pankhudi'
          },
          {
            path: 'closed-projects',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/closed-project/closed-project.component').then(c => c.ClosedProjectComponent),
            title: 'Closed Projects | Pankhudi'
          },
          {
            path: 'create-projects',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/institution-wise-project/institution-wise-project.component').then(c => c.InstitutionWiseProjectComponent),
            title: 'Closed Projects | Pankhudi'
          },
          {
            path: 'add-project',
            loadComponent: () =>
              import('./admin/components/project/add-project/add-project.component').then(c => c.AddProjectComponent),
            title: 'Add Projects | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'view-project',
            loadComponent: () =>
              import('./admin/components/project/view-project/view-project.component').then(c => c.ViewProjectComponent),
            title: 'View Projects | Pankhudi'
          },
          {
            path: 'proposal-list',
            canMatch: [authGuard],
            loadComponent: () =>
              //  import('./admin/components/users-count/users-count.component').then(c => c.UsersCountComponent),
              import('./admin/components/project/proposal-list/proposal-list.component').then(c => c.ProposalListComponent),
            title: 'Proposal | Pankhudi'
          },

          {
            path: 'feedbacks',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/contributor-feedback-list/contributor-feedback-list.component').then(c => c.ContributorFeedbackComponent),
            title: 'Feedbacks | Pankhudi'
          },
          {
            path: 'public-feedback',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/public-feedback-list/public-feedback-list.component').then(c => c.PublicFeedbackListComponent),
            title: 'Feedbacks | Pankhudi'
          },
          {
            path: 'portal-maintenance',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/maintance/maintance.component').then(c => c.MaintanceComponent),
            title: 'Portal Maintenance | Pankhudi'
          },
          {
            path: 'view-project-details',
            loadComponent: () =>
              import('./admin/components/project/view-project-details/view-project-details.component').then(c => c.ViewProjectDetailsComponent),
            title: 'View Project Detail | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'project-contribution-detail',
            loadComponent: () =>
              import('./admin/components/project/project-contribution-detail/project-contribution-detail.component').then(c => c.ProjectContributionDetailComponent),
            title: 'Project Contribution Detail | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'contributor-details',
            loadComponent: () =>
              import('./admin/components/project/contributors-list/contributors-list.component').then(c => c.ContributorsListComponent),
            title: 'ContributorDetail | Pankhudi'
          },
          {
            path: 'project-search',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/project/project-search/project-search.component').then(c => c.ProjectSearchComponent),
            title: 'Project Search | Pankhudi'
          },
          {
            path: 'project-contribution',
            loadComponent: () =>
              import('./admin/components/project/contribution-under-project/contribution-under-project.component').then(c => c.ContributionUnderProjectComponent),
            title: 'Project Contribution | Pankhudi'
          },
          {
            path: 'view-project-contribution-details',
            loadComponent: () =>
              import('./admin/components/project/view-project-contribution-details/view-project-contribution-details').then(c => c.ViewProjectContributionDetailsComponent),
            title: 'View Project Contribution Details | Pankhudi'
          },
          {
            path: 'view-project-delivery',
            loadComponent: () =>
              import('./admin/components/project/project-delivary/project-delivary.component').then(c => c.ProjectDelivaryComponent),
            title: 'View Project Delivery | Pankhudi'
          },
          {
            path: 'view-project-participant-approval',
            loadComponent: () =>
              import('./admin/components/project/project-parti-approval/project-parti-approval.component').then(c => c.ProjectPartiApprovalComponent),
            title: 'View Project Participant Approval | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'contributor-approval-history',
            loadComponent: () =>
              import('./admin/components/project/contributor-approve-history/contributor-approve-history.component').then(c => c.ContributorApproveHistoryComponent),
            title: 'Contributor Approval History | Pankhudi'
          }, {
            path: 'project-approval-history',
            loadComponent: () =>
              import('./admin/components/project/project-approval-history/project-approval-history.component').then(c => c.ProjectApprovalHistoryComponent),
            title: 'Project Approval History | Pankhudi'
          },
          {
            path: 'administrative-users',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/users-list/users-list.component').then(c => c.UsersListComponent),
            title: 'Administrative Users | Pankhudi'
          },
          {
            path: 'volunteer-users',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/volunteer-user/volunteer-user.component').then(c => c.VolunteerUserComponent),
            title: 'Volunteer Users | Pankhudi'
          },
          {
            path: 'registration',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/register-user/register-user.component').then(c => c.RegisterUserComponent),
            title: 'Registration | Pankhudi'
          },
          {
            path: 'add-administrator-user',
            loadComponent: () =>
              import('./admin/components/users-list/add-administer-user/add-administer-user.component').then(c => c.AddAdministerUserComponent),
            title: 'Add Administrator User | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'view-administrator-user',
            loadComponent: () =>
              import('./admin/components/users-list/view-administrator-user/view-administrator-user.component').then(c => c.ViewAdministratorUserComponent),
            title: 'View Administrator User | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'additional-contribution-request',
            loadComponent: () =>
              import('./admin/components/additional-contribution-request/additional-contribution-request.component').then(c => c.AdditionalContributionRequestComponent),
            title: 'Additional Contribution Request | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'loginlogs',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/login-logs/login-logs.component').then(c => c.LoginLogsComponent),
            title: 'Login Logs | Pankhudi'
          },
          {
            path: 'user-login-summary',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/mis-report/mis-report.component').then(c => c.MisReportComponent),
            title: 'User Login Summary | Pankhudi'
          },
          {
            path: 'user-institutions',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/user-institutions/user-institutions.component').then(c => c.UserInstitutionsComponent),
            title: 'User Institutions | Pankhudi'
          },
          {
            path: 'your-queries',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/raise-query/query-list/query-list.component').then(c => c.QueryListComponent),
            title: 'Your Queries | Pankhudi'
          },
          {
            path: 'queries-complaint',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/recieved-query/recived-query-list.component').then(c => c.RecievedQueryListComponent),
            title: 'Queries Complaint | Pankhudi'
          },
          {
            path: 'view-user-profile',
            loadComponent: () =>
              import('./authentication/view-user-detail/view-user-detail.component').then(c => c.ViewUserDetailComponent),
            title: 'View User Profile | Pankhudi'
          },
          {
            path: 'master/unitofmeasurement',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/masters/unit/unit.component').then(c => c.UnitComponent),
            title: 'Unit of Measurement | Pankhudi'
          },
          {
            path: 'master/missions',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/masters/scheme/scheme.component').then(c => c.SchemeComponent),
            title: 'Missions | Pankhudi'
          },
          {
            path: 'master/schemes',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/masters/sub-scheme/sub-scheme.component').then(c => c.SubSchemeComponent),
            title: 'Schemes | Pankhudi'
          },
          {
            path: 'masters/states',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/masters/state/state.component').then(c => c.StateComponent),
            title: 'States | Pankhudi'
          },
          {
            path: 'masters/districts',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/masters/district/district.component').then(c => c.DistrictComponent),
            title: 'Districts | Pankhudi'
          },
          {
            path: 'master/activities',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/masters/activities/activities.component').then(c => c.ActivitiesComponent),
            title: 'Activities | Pankhudi'
          },
          {
            path: 'master/category',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/masters/category/category.component').then(c => c.CategoryComponent),
            title: 'Category | Pankhudi'
          },
          {
            path: 'supervisor-cdpo-mapping',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/users-count/users-count.component').then(c => c.UsersCountComponent),
            title: 'Supervisor-Cdpo Mapping | Pankhudi'
          },
          {
            path: 'master/sub-category',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/masters/sub-category/sub-category.component').then(c => c.SubCategoryComponent),
            title: 'Sub Category | Pankhudi'
          },
          {
            path: 'user-institution-mapping',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/user-institutions/user-institutions.component').then(c => c.UserInstitutionsComponent),
            title: 'User Institutions | Pankhudi'
          },
          {
            path: 'master/users-count',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/users-count/users-count.component').then(c => c.UsersCountComponent),
            title: 'Users Count | Pankhudi'
          },
          {
            path: 'master/institution-list',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/masters/institution-list/institution-list.component').then(c => c.InstitutionListComponent),
            title: 'Institution | Pankhudi'
          },
          {
            path: 'update-user-anganwadi',
            loadComponent: () =>
              import('./admin/components/update-user-anganwadi/update-user-anganwadi.component').then(c => c.UpdateUserAnganwadiComponent),
            title: 'Update User Anganwadi | Pankhudi'
          },
          {
            path: 'document',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/documents/documents.component').then(c => c.DocumentsComponent),
            title: 'Document | Pankhudi'
          },

          {
            path: 'change_password',
            loadComponent: () =>
              import('./admin/components/change-password/change-password.component').then(c => c.ChangePasswordComponent),
            title: 'Change Password | Pankhudi'
          },
          {
            path: 'cms/menu',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/cms-menu/cms-menu.component').then(c => c.CmsMenuComponent),
            title: 'Menu | Pankhudi'
          },
          {
            path: 'role-access-rights',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/menu-tab/menu-tab.component').then(c => c.MenuTabComponent),
            title: 'Role Access Rights | Pankhudi'
          },
          {
            path: 'cms/pages',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/pages-list/pages-list.component').then(c => c.PagesListComponent),
            title: 'Pages | Pankhudi'
          },
          {
            path: 'cms/news',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/announcement-news-event/announcement-news-event.component').then(c => c.AnnouncementNewsEventComponent),
            title: 'News | Pankhudi'
          },
          {
            path: 'cms/events',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/announcement-news-event/announcement-news-event.component').then(c => c.AnnouncementNewsEventComponent),
            title: 'Events | Pankhudi'
          },
          {
            path: 'cms/announcements',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/announcement-news-event/announcement-news-event.component').then(c => c.AnnouncementNewsEventComponent),
            title: 'Announcements | Pankhudi'
          },
          {
            path: 'cms/photo/gallery',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/photos-list/photos-list.component').then(c => c.PhotosListComponent),
            title: 'Gallery | Pankhudi'
          },
          {
            path: 'add_page',
            loadComponent: () =>
              import('./admin/components/pages/pages.component').then(c => c.PagesComponent),
            title: 'Add Page | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'update_page',
            loadComponent: () =>
              import('./admin/components/pages/pages.component').then(c => c.PagesComponent),
            title: 'Update Page | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'templet',
            loadComponent: () =>
              import('./admin/components/banner-social-layout/banner-social-layout.component').then(c => c.BannerSocialLayoutComponent),
            title: 'Templete | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'cms/media',
            canMatch: [authGuard],
            loadComponent: () =>
              import('./admin/components/media/media.component').then(c => c.MediaComponent),
            title: 'Media | Pankhudi'
          },
          {
            path: 'material-assets-equipment-list',
            loadComponent: () =>
              import('./contribute-details/contribute-details.component').then(c => c.ContributeDetailsComponent),
            title: 'Material Assets Equipment | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'activities-services-list',
            loadComponent: () =>
              import('./contribute-details/contribute-details.component').then(c => c.ContributeDetailsComponent),
            title: 'Activities Services | Pankhudi',
            canActivate: [UserMatchGuard]
          },
          {
            path: 'import/import-institutions',
            loadComponent: () =>
              import('./admin/components/export-institutions/export-institutions.component').then(c => c.ExportInstitutionsComponent),
          },
        ],
        loadComponent: () =>
          import('./admin/components/admin-layout/admin-layout.component').then(c => c.AdminLayoutComponent),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./admin/components/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent),
      },
    ],
  },
  {
    path: 'web',
    loadComponent: () =>
      import('./layout/layout.component').then(c => c.LayoutComponent),
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },

      {
        path: 'home',
        loadComponent: () =>
          import('./home/home.component').then(c => c.HomeComponent),
        data: {
          title: 'Homepage',
          description: 'Welcome to Pankhudi portal'
        }
      },
      {
        path: 'view/:id',
        loadComponent: () => import('./home/view-event-news/view-event-news.component').then(c => c.ViewEventNewsComponent),
        data: {
          title: 'Event',
          description: 'News '
        }
      },
      {
        path: 'gallery',
        loadComponent: () =>
          import('./home/view-gallery/view-gallery.component').then(c => c.ViewGalleryComponent),
        data: {
          title: 'Gallery',
          description: 'Gallery '
        }
      },
      {
        path: 'register',
        loadComponent: () => import('./authentication/ragistration/ragistration.component').then(c => c.RagistrationComponent),
        data: {
          title: 'Register',
          description: 'register'
        }
      },
      {
        path: 'login',
        loadComponent: () => import('./authentication/login/login.component').then(c => c.LoginComponent),
        data: {
          title: 'login',
          description: 'login'
        }
      },

      {
        path: 'screen_reader_access',
        loadComponent: () => import('./screen-reader-access/screen-reader-access.component').then(c => c.ScreenReaderAccessComponent),
        data: {
          title: 'Screen Reader Access',
          description: 'Screen Reader Access'
        }
      },
      {
        path: 'faq',
        loadComponent: () => import('./faq/faq.component').then(c => c.FaqComponent),
        data: {
          title: 'FAQ',
          description: 'Frequently Asked Questions'
        }
      },
      {
        path: 'preview-pages',
        loadComponent: () => import('./preview/preview.component').then(c => c.PreviewComponent),
        data: {
          title: 'Preview-Pages',
          description: 'Preview-Pages'
        }
      },
      {
        path: 'globle-search',
        loadComponent: () => import('./headers/search/search.component').then(c => c.SearchComponent),
        data: {
          title: 'Search | Pankhudi',
          description: 'Search'
        }
      },
      {
        path: 'live-projects-detail',
        loadComponent: () => import('./live-project-details/live-project-details.component').then(c => c.LiveProjectDetailsComponent),
        data: {
          title: 'Live Projects Detail',
          description: 'Live Projects Detail'
        }
      },
      {
        path: 'live-projects-contribute',
        loadComponent: () => import('./admin/components/project/view-project-contribution-details/view-project-contribution-details').then(c => c.ViewProjectContributionDetailsComponent),
        data: {
          title: 'Live Projects Contribute',
          description: 'Live Projects Contribute'
        }
      },
      {
        path: 'contribute-projects-detail',
        loadComponent: () => import('./contribute-details/contribute-details.component').then(c => c.ContributeDetailsComponent),
        data: {
          title: 'Contribute Projects Detail',
          description: 'Contribute Projects Detail'
        }
      },
      {
        path: 'project-dashboard',
        loadComponent: () => import('./project-dashboard/project-dashboard.component').then(c => c.ProjectDashboardComponent),
        data: {
          title: 'Public Dashboard | Pankhudi',
          description: 'Public dashboard'
        }
      },
      {
        path: ':slug',
        loadComponent: () => import('./dynamic-page/dynamic-page.component').then(c => c.DynamicPageComponent),
        runGuardsAndResolvers: 'always'
      }
    ],
  },

  {
    path: '',
    redirectTo: 'web/home',
    pathMatch: 'full',
  },

];
